export enum EChildernName {
    OwnersComponent = 'Owners',
}

